// Descripción de Instagram de una imagen generada — webhook n8n
// `descripcion_instagram` migrado a atlas `/v1/images/instagram-description`
// (ADR-605). Flag ADENTRO del helper:
//   ON  → atlas con JWT (`user_id` NO viaja) + modo_utilizado
//         'descripcion_instagram'. La respuesta además trae
//         `post_description` directa → los callers la usan y se saltean el
//         poll de la fila (que queda como fallback).
//   OFF → webhook n8n byte-idéntico (solo {response:'success'}; el caller
//         pollea la fila como siempre).

import { GENERATE_AUTH_TOKEN, USE_ATLAS_BACKEND } from '../config';
import { atlasBackendFetch } from './atlasBackend';

const DESCRIPCION_INSTAGRAM_URL =
  'https://ai-agency-dt7d.onrender.com/webhook/descripcion_instagram';

export interface InstagramDescriptionResult {
  ok: boolean;
  /** Solo del atlas: la descripción ya resuelta (skip del poll). */
  postDescription?: string;
}

export async function postInstagramDescription(body: {
  user_id: string;
  image_id: string | number;
}): Promise<InstagramDescriptionResult> {
  if (USE_ATLAS_BACKEND) {
    const { user_id: _ignored, ...atlasBody } = body;
    const res = await atlasBackendFetch('/v1/images/instagram-description', {
      ...atlasBody,
      modo_utilizado: 'descripcion_instagram',
    });
    const data = (await res.json().catch(() => null)) as {
      response?: string;
      post_description?: string;
    } | null;
    return {
      ok: data?.response === 'success',
      postDescription:
        typeof data?.post_description === 'string' &&
        data.post_description.trim()
          ? data.post_description
          : undefined,
    };
  }
  const res = await fetch(DESCRIPCION_INSTAGRAM_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: GENERATE_AUTH_TOKEN,
    },
    body: JSON.stringify(body),
  });
  const data = (await res.json().catch(() => null)) as {
    response?: string;
  } | null;
  return { ok: data?.response === 'success' };
}
